module.exports = __webpack_public_path__ + "img/Final-Logo-Iris-04-03.ef83f728.png";